import Download from '@uhg-uicl/ui-core/dist/Download';
import Trash from '@uhg-uicl/ui-core/dist/Trash';
import Pen from '@uhg-uicl/ui-core/dist/Pen';
import { GridCell } from '@uhg-uicl/ui-core/dist';
import {
  PrepayClaimHeaderType,
  PrepayClaimMemberType,
  PrepayClaimPatientType,
  PrepayClaimsPageStateType,
} from './types';
import { SelectDropdownValue } from '@uhg-uicl/ui-core/dist/Atoms/SelectDropdown/types';
export enum ActionTypesPrePayClaimsPage {
  GET_CLAIM_LINES = 'src/containers/PrepayClaimsPage/GET_CLAIM_LINES',
  TOGGLE_CLAIM_LINES_LOADING = 'src/containers/PrePayClaimsPage/TOGGLE_CLAIM_LINES_LOADING',
  SET_PREPAY_CLAIMS_LINES_GRID_DATA = 'src/containers/PrePayClaimsPage/SET_PREPAY_CLAIMS_LINES_GRID_DATA',
  SET_PREPAY_CLAIM_PATIENT_MEMBER_DATA = 'src/containers/PrePayClaimsPage/SET_PREPAY_CLAIM_PATIENT_MEMBER_DATA',
  SET_PROVIDER_DATA = 'src/containers/PrePayClaimsPage/SET_PROVIDER_DATA',
  SET_EOR_VERSIONS_DATA = 'src/containers/PrePayClaimsPage/SET_EOR_VERSIONS_DATA',
  TOGGLE_PROVIDER_LOADING = 'src/containers/PrePayClaimsPage/TOGGLE_PROVIDER_LOADING',
  TOGGLE_CLAIM_HEADER_LOADING = 'src/containers/PrePayClaimsPage/TOGGLE_CLAIM_HEADER_LOADING',
  TOGGLE_CLAIM_PATIENT_MEMBER_LOADING = 'src/containers/PrePayClaimsPage/TOGGLE_CLAIM_PATIENT_LOADING',
  SET_PREPAY_CLAIM_LINES_GRID_DATA = 'src/containers/PrePayClaimsPage/SET_PREPAY_CLAIM_LINES_GRID_DATA',
  SET_PREPAY_CLAIM_HEADER_DETAILS = 'src/containers/PrePayClaimsPage/SET_PREPAY_CLAIM_HEADER_DETAILS',
  TOGGLE_CLAIM_CUSTOM_NOTES_LOADING = 'src/containers/PrePayClaimsPage/TOGGLE_CLAIM_CUSTOM_NOTES_LOADING',
  TOGGLE_EOR_VERSIONS_LOADING = 'src/containers/PrePayClaimsPage/TOGGLE_EOR_VERSIONS_LOADING',
  TOGGLE_CLAIM_ATTACHMENTS_LOADING = 'src/containers/PrePayClaimsPage/TOGGLE_CLAIM_ATTACHMENTS_LOADING',
  TOGGLE_APPEAL_ATTACHMENTS_LOADING = 'src/containers/PrePayClaimsPage/TOGGLE_APPEAL_ATTACHMENTS_LOADING',
  TOGGLE_DETAIL_PANE_LOADING = 'src/containers/PrePayClaimsPage/TOGGLE_DETAIL_PANE_LOADING',
  TOGGLE_INVOICE_ACTIVITIES_LOADING = 'src/containers/PrePayClaimsPage/TOGGLE_INVOICE_ACTIVITIES_LOADING',
  TOGGLE_CREATE_PORTAL_EOR_LOADING = 'src/containers/PrePayClaimsPage/TOGGLE_CREATE_PORTAL_EOR_LOADING',
  SET_PREPAY_CLAIM_ATTACHMENTS_DATA = 'src/containers/PrePayClaimsPage/SET_PREPAY_CLAIM_ATTACHMENTS_DATA',
  TOGGLE_CLAIM_ACTIVITY_INFO_LOADING = 'src/containers/PrePayClaimsPage/TOGGLE_CLAIM_ACTIVITY_INFO_LOADING',
  SET_CLAIM_ACTIVITY_INFO_DATA = 'src/containers/PrePayClaimsPage/SET_CLAIM_ACTIVITY_INFO_DATA',
  SET_PREPAY_CLAIM_SEARCH_DATA = 'src/containers/PrePayClaimsPage/SET_PREPAY_CLAIM_SEARCH_DATA',
  SET_PORTAL_EOR_PDF = 'src/containers/PrePayClaimsPage/SET_PORTAL_EOR_PDF',
  SET_PORTAL_EOR_PDF1 = 'src/containers/PrePayClaimsPage/SET_PORTAL_EOR_PDF1',
  CLEAR_PREPAY_CLAIM_DETAIL_PANE_REDUX_DATA = 'src/containers/PrePayClaimsPage/CLEAR_PREPAY_CLAIM_DETAIL_PANE_REDUX_DATA',
  CLEAR_EOR_VERSIONS_DATA = 'src/containers/PrePayClaimsPage/CLEAR_EOR_VERSIONS_DATA',
  SET_NOTIFICATION_VISIBLE = 'src/containers/PrePayClaimsPage/SET_NOTIFICATION_VISIBLE',
  SET_OPEN_ANIMATION = 'src/containers/PrePayClaimsPage/SET_OPEN_ANIMATION',
  SET_CLOSE_ANIMATION = 'src/containers/PrepayClaimsPage/SET_CLOSE_ANIMATION',
  TOGGLE_APPEALS_OF_CLAIMID_LOADING = 'src/containers/PrepayClaimsPage/TOGGLE_APPEALS_OF_CLAIMID_LOADING',
  SET_APPEALS_OF_CLAIMID_DATA = 'src/containers/PrepayClaimsPage/SET_APPEALS_OF_CLAIMID_DATA',
  TOGGLE_INQUIRIES_OF_CLAIMID_LOADING = 'src/containers/PrepayClaimsPage/TOGGLE_INQUIRIES_OF_CLAIMID_LOADING',
  SET_INQUIRIES_OF_CLAIMID_DATA = 'src/containers/PrepayClaimsPage/SET_INQUIRIES_OF_CLAIMID_DATA',
  SET_PREPAY_CLAIMS_DETAIL_PANE_BREADCRUMB_ITEMS = 'src/containers/PrepayClaimsPage/SET_PREPAY_CLAIMS_DETAIL_PANE_BREADCRUMB_ITEMS',
  SET_PREPAY_CLAIM_INVOICE_ACTIVITIES_DATA = 'src/containers/PrepayClaimsPage/SET_PREPAY_CLAIM_INVOICE_ACTIVITIES_DATA',
  SET_CLAIM_ROUTING_INFO = 'src/containers/PrepayClaimsPage/SET_CLAIM_ROUTING_INFO',
  TOGGLE_IS_CLAIM_OPERATIONS_ACTION_LOADING = 'src/containers/PrepayClaimsPage/TOGGLE_IS_CLAIM_OPERATIONS_ACTION_LOADING',
  TOGGLE_INQUIRY_CREATE_LOOPKUP_LOADING = 'src/containers/PrepayClaimsPage/TOGGLE_INQUIRY_CREATE_LOOPKUP_LOADING',
  SET_INQUIRY_CREATE_LOOPKUP_DATA = 'src/containers/PrepayClaimsPage/SET_INQUIRY_CREATE_LOOPKUP_DATA',
  TOGGLE_INQUIRY_CREATE_LOADING = 'src/containers/PrepayClaimsPage/TOGGLE_INQUIRY_CREATE_LOADING',
  SET_INQUIRY_CREATE_DATA = 'src/containers/PrepayClaimsPage/SET_INQUIRY_CREATE_DATA',
  TOGGLE_INQUIRY_UPDATE_COMPLETE = 'src/containers/PrepayClaimsPage/TOGGLE_INQUIRY_UPDATE_COMPLETE',
  TOGGLE_INQUIRY_UPDATE_LOADING = 'src/containers/PrepayClaimsPage/TOGGLE_INQUIRY_UPDATE_LOADING',
  SET_ADJUST_SAVING_CLIENT_DROPDOWNS = 'src/containers/PrepayClaimsPage/SET_ADJUST_SAVING_CLIENT_DROPDOWNS',
  TOGGLE_ADJUST_SAVINGS_DROPDOWN_LOADING = 'src/containers/PrepayClaimsPage/TOGGLE_ADJUST_SAVINGS_DROPDOWN_LOADING',
  TOGGLE_ADJUST_SAVINGS_LOADING = 'src/containers/PrepayClaimsPage/TOGGLE_ADJUST_SAVINGS_LOADING',
  TOGGLE_IS_CLAIM_ROUTING_LOADING = 'src/containers/PrepayClaimsPage/TOGGLE_IS_CLAIM_ROUTING_LOADING',
  SET_ADJUSTMENT_DROPDOWNS = 'src/containers/PrepayClaimsPage/SET_ADJUSTMENT_DROPDOWNS',
  SET_FILE_TO_EDIT = 'src/containers/PrepayClaimsPage/SET_FILE_TO_EDIT',
  CLEAR_ATTACHMENT_MODAL_REDUX_DATA = 'src/containers/PrepayClaimsPage/CLEAR_ATTACHMENT_MODAL_REDUX_DATA',
  SET_CLAIMS_GRID_COLUMN_CONFIG = 'SET_CLAIMS_GRID_COLUMN_CONFIG',
}
export const ADJUST_SAVINGS_GRID_COLUMNS = new Set([
  {
    dataName: 'lineNum',
    text: '',
    sortable: true,
    isSorted: 0,
    headerWidth: 10,
    isHeaderTruncated: true,
    align: 'left',
  },
  {
    dataName: 'beginDOS',
    text: 'Begin DOS',
    sortable: true,
    isSorted: 0,
    headerWidth: 90,
    isHeaderTruncated: true,
    align: 'left',
  },
  {
    dataName: 'endDOS',
    text: 'End DOS',
    sortable: true,
    isSorted: 0,
    headerWidth: 90,
    isHeaderTruncated: true,
    align: 'left',
  },
  {
    dataName: 'pos',
    text: 'POS',
    sortable: true,
    isSorted: 0,
    headerWidth: 70,
    isHeaderTruncated: true,
    align: 'left',
  },
  {
    dataName: 'code',
    text: 'Code',
    sortable: true,
    isSorted: 0,
    headerWidth: 70,
    isHeaderTruncated: true,
    align: 'left',
  },

  // {
  //   dataName: 'description',
  //   text: 'Description',
  //   sortable: true,
  //   isSorted: 0,
  //   headerWidth: 300,
  //   isHeaderTruncated: true,
  //   align: 'left',
  // },
  {
    dataName: 'units',
    text: 'Unit',
    sortable: true,
    isSorted: 0,
    headerWidth: 60,
    isHeaderTruncated: true,
    align: 'right',
  },
  {
    dataName: 'billedCharge',
    text: 'Billed Charges',
    sortable: true,
    isSorted: 0,
    headerWidth: 95,
    isHeaderTruncated: true,
    align: 'right',
  },
  {
    dataName: 'allowed',
    text: 'Allowed',
    sortable: true,
    isSorted: 0,
    headerWidth: 95,
    isHeaderTruncated: true,
    align: 'right',
  },
  {
    dataName: 'recAmount',
    text: 'Rec. Amount',
    sortable: true,
    isSorted: 0,
    headerWidth: 95,
    isHeaderTruncated: true,
    align: 'right',
  },
  {
    dataName: 'savings',
    text: 'Savings',
    sortable: true,
    isSorted: 0,
    headerWidth: 95,
    isHeaderTruncated: true,
    align: 'right',
    cellType: 'custom',
  },
  {
    dataName: 'status',
    text: 'Status',
    sortable: true,
    isSorted: 0,
    headerWidth: 145,
    isHeaderTruncated: true,
    align: 'left',
    cellType: 'custom',
  },
  {
    dataName: 'service',
    text: 'Service',
    sortable: true,
    isSorted: 0,
    headerWidth: 145,
    isHeaderTruncated: true,
    align: 'left',
    cellType: 'custom',
  },
  {
    dataName: 'network',
    text: 'Network',
    sortable: true,
    isSorted: 0,
    headerWidth: 170,
    isHeaderTruncated: true,
    align: 'left',
    cellType: 'custom',
  },
  {
    dataName: 'reason',
    text: 'Reason',
    sortable: true,
    isSorted: 0,
    headerWidth: 200,
    isHeaderTruncated: true,
    align: 'left',
    cellType: 'custom',
  },
  {
    dataName: 'partnerClaimId',
    text: 'Part. Clm. ID',
    sortable: true,
    isSorted: 0,
    headerWidth: 120,
    isHeaderTruncated: true,
    align: 'left',
  },
  {
    dataName: 'partnerClaimDate',
    text: 'Part. Clm. Date',
    sortable: true,
    isSorted: 0,
    headerWidth: 120,
    isHeaderTruncated: true,
    align: 'left',
  },
]);
export const CLAIM_LINE_DETAILS_GRID_COLUMNS = new Set([
  {
    dataName: 'lineNum',
    text: '',
    sortable: true,
    isSorted: 0,
    minWidth: '80px',
    align: 'left',
    cellType: 'custom',
  },
  {
    dataName: 'beginDOS',
    text: 'Begin DOS',
    sortable: true,
    isSorted: 0,
    minWidth: '120px',
    align: 'left',
  },
  {
    dataName: 'endDOS',
    text: 'End DOS',
    sortable: true,
    isSorted: 0,
    minWidth: '100px',
    align: 'left',
  },
  {
    dataName: 'pos',
    text: 'POS',
    sortable: true,
    isSorted: 0,
    minWidth: '80px',
    align: 'left',
  },
  {
    dataName: 'code',
    text: 'Code (Rev/CPT/Modifier)',
    sortable: true,
    isSorted: 0,
    minWidth: '200px',
    align: 'left',
  },

  {
    dataName: 'description',
    text: 'Description',
    sortable: true,
    isSorted: 0,
    minWidth: '300px',
    align: 'left',
  },
  {
    dataName: 'units',
    text: 'Unit',
    sortable: true,
    isSorted: 0,
    minWidth: '80px',
    align: 'right',
  },
  {
    dataName: 'billedCharge',
    text: 'Billed Charges',
    sortable: true,
    isSorted: 0,
    minWidth: '150px',
    align: 'right',
  },
  {
    dataName: 'allowed',
    text: 'Allowed',
    sortable: true,
    isSorted: 0,
    minWidth: '100px',
    align: 'right',
  },
  {
    dataName: 'savings',
    text: 'Savings',
    sortable: true,
    isSorted: 0,
    minWidth: '100px',
    align: 'right',
  },
  {
    dataName: 'recAmount',
    text: 'Rec. Amount',
    sortable: true,
    isSorted: 0,
    minWidth: '150px',
    align: 'right',
  },
  {
    dataName: 'explanationCode',
    text: 'Exp Code',
    sortable: true,
    isSorted: 0,
    minWidth: '120px',
    align: 'left',
    cellType: 'custom',
  },
  {
    dataName: 'netCode',
    text: 'NetCode',
    sortable: true,
    isSorted: 0,
    minWidth: '100px',
    align: 'left',
  },
  {
    dataName: 'netName',
    text: 'NetName',
    sortable: true,
    isSorted: 0,
    minWidth: '150px',
    align: 'left',
  },
]);

export const NESTED_CLAIM_LINE_DETAILS_GRID_COLUMNS = new Set([
  {
    dataName: 'lineNum',
    text: '',
    sortable: true,
    isSorted: 0,
    minWidth: '60px',
    align: 'left',
    cellType: 'custom',
  },
  {
    dataName: 'beginDOS',
    text: 'Begin DOS',
    sortable: true,
    isSorted: 0,
    minWidth: '80px',
    align: 'left',
  },
  {
    dataName: 'endDOS',
    text: 'End DOS',
    sortable: true,
    isSorted: 0,
    minWidth: '80px',
    align: 'left',
  },
  {
    dataName: 'code',
    text: 'Code (Rev/CPT/Modifier)',
    sortable: true,
    isSorted: 0,
    minWidth: '150px',
    align: 'left',
  },
  {
    dataName: 'billedCharge',
    text: 'Billed Charges',
    sortable: true,
    isSorted: 0,
    minWidth: '80px',
    align: 'right',
  },
  {
    dataName: 'allowed',
    text: 'Allowed',
    sortable: true,
    isSorted: 0,
    minWidth: '80px',
    align: 'right',
  },
  {
    dataName: 'savings',
    text: 'Savings',
    sortable: true,
    isSorted: 0,
    minWidth: '80px',
    align: 'right',
  },
  {
    dataName: 'recAmount',
    text: 'Rec. Amount',
    sortable: true,
    isSorted: 0,
    minWidth: '80px',
    align: 'right',
  },
  {
    dataName: 'eorNote',
    text: 'EOR Note',
    sortable: true,
    isSorted: 0,
    minWidth: '150px',
    align: 'left',
  },
  {
    dataName: 'serviceId',
    text: 'Service',
    sortable: true,
    isSorted: 0,
    minWidth: '100px',
    align: 'left',
  },
]);
export const CLAIM_PATIENT_GRID_COLUMNS = new Set([
  {
    dataName: 'patientName',
    text: 'Name',
    sortable: true,
    isSorted: 0,
    align: 'left',
    width: '170px',
  },
  {
    dataName: 'patientId',
    text: 'Patient ID',
    sortable: true,
    isSorted: 0,
    align: 'left',
    width: '170px',
  },
  {
    dataName: 'patientDOB',
    text: 'DOB',
    sortable: true,
    isSorted: 0,
    align: 'left',
    width: '100px',
  },
  {
    dataName: 'patientGender',
    text: 'Gender',
    sortable: true,
    isSorted: 0,
    align: 'left',
    width: '90px',
  },
  {
    dataName: 'patientAddress',
    text: 'Address',
    sortable: true,
    isSorted: 0,
    align: 'left',
    width: '220px',
  },
  {
    dataName: 'patientPhone',
    text: 'Phone',
    sortable: true,
    isSorted: 0,
    align: 'left',
    width: '180px',
  },
  {
    dataName: 'patientRelCode',
    text: 'Relationship',
    sortable: true,
    isSorted: 0,
    align: 'left',
    width: '180px',
  },
]);
export const CLAIM_MEMBER_GRID_COLUMNS = new Set([
  {
    dataName: 'memberName',
    text: 'Name',
    sortable: true,
    isSorted: 0,
    align: 'left',
    width: '170px',
  },
  {
    dataName: 'memberId',
    text: 'Member ID',
    sortable: true,
    isSorted: 0,
    align: 'left',
    width: '170px',
  },
  {
    dataName: 'memberDOB',
    text: 'DOB',
    sortable: true,
    isSorted: 0,
    align: 'left',
    width: '100px',
  },
  {
    dataName: 'memberGender',
    text: 'Gender',
    sortable: true,
    isSorted: 0,
    align: 'left',
    width: '90px',
  },
  {
    dataName: 'memberAddress',
    text: 'Address',
    sortable: true,
    isSorted: 0,
    align: 'left',
    width: '220px',
  },
  {
    dataName: 'memberPhone',
    text: 'Phone',
    sortable: true,
    isSorted: 0,
    align: 'left',
    width: '180px',
  },
  {
    dataName: 'memberGroup',
    text: 'Group',
    sortable: true,
    isSorted: 0,
    align: 'left',
    width: '180px',
  },
]);
export const CLAIM_PROVIDER_GRID_COLUMNS = new Set([
  {
    dataName: 'type',
    text: 'Type',
    sortable: true,
    isSorted: 0,
    minWidth: '110px',
    align: 'left',
  },
  {
    dataName: 'name',
    text: 'Name',
    sortable: true,
    isSorted: 0,
    minWidth: '260px',
    align: 'left',
  },
  {
    dataName: 'tin',
    text: 'TIN/ID',
    sortable: true,
    isSorted: 0,
    align: 'left',
    minWidth: '120px',
  },
  {
    dataName: 'npi',
    text: 'NPI',
    sortable: true,
    isSorted: 0,
    align: 'left',
    minWidth: '110px',
  },
  {
    dataName: 'taxonomy',
    text: 'Taxonomy',
    sortable: true,
    isSorted: 0,
    align: 'left',
    minWidth: '120px',
  },
  {
    dataName: 'specialty',
    text: 'Specialty',
    sortable: true,
    isSorted: 0,
    align: 'left',
    minWidth: '120px',
  },
  {
    dataName: 'address',
    text: 'Address',
    sortable: true,
    isSorted: 0,
    minWidth: '200px',
    align: 'left',
  },
  {
    dataName: 'phone',
    text: 'Phone',
    sortable: true,
    isSorted: 0,
    align: 'left',
    minWidth: '150px',
  },
]);

export const CLAIM_ANALYZED_GRID_COLUMNS = new Set([
  {
    dataName: 'lineNum',
    text: '',
    sortable: true,
    isSorted: 0,
    minWidth: '80px',
    align: 'left',
  },
  {
    dataName: 'cpt',
    text: 'CPT (includes Rev. Code, CPT, Modifier)',
    sortable: true,
    isSorted: 0,
    minWidth: '260px',
    align: 'left',
  },
  {
    dataName: 'units',
    text: 'Units',
    sortable: true,
    isSorted: 0,
    align: 'right',
    minWidth: '110px',
  },
  {
    dataName: 'billedCharge',
    text: 'Billed Charge',
    sortable: true,
    isSorted: 0,
    align: 'right',
    minWidth: '110px',
  },
  {
    dataName: 'chcClaimId',
    text: 'Claim ID (Reference)',
    sortable: true,
    isSorted: 0,
    align: 'left',
    minWidth: '110px',
  },
]);

export const CLAIM_ATTACHMENTS_GRID_COLUMNS = new Set([
  {
    dataName: 'modifiedBy',
    text: 'User',
    sortable: true,
    isSorted: 0,
  },
  {
    dataName: 'fileName',
    text: 'File Name',
    sortable: true,
    isSorted: 0,
  },
  {
    dataName: 'download',
    text: <GridCell cellType="icon" data={{ icon: Download }} />,
    sortable: true,
    isSorted: 0,
    cellType: 'custom',
  },

  {
    dataName: 'description',
    text: 'Notes',
    sortable: true,
    isSorted: 0,
  },

  {
    dataName: 'modifiedDate',
    text: 'Date/Time',
    sortable: true,
    isSorted: 0,
  },
  {
    dataName: 'internalFlag',
    text: 'I/E',
    sortable: true,
    isSorted: 0,
    cellType: 'chip',
  },
  {
    dataName: 'editIcon',
    text: <GridCell cellType="icon" data={{ icon: Pen }} />,
    sortable: true,
    isSorted: 0,
    cellType: 'custom',
  },
  {
    dataName: 'trashIcon',
    text: <GridCell cellType="icon" data={{ icon: Trash }} />,
    sortable: true,
    isSorted: 0,
    cellType: 'custom',
  },
]);

export const CLAIMS_ANALYZED_GRID_COLUMNS = new Set([
  {
    dataName: 'clientClaimId',
    text: 'Client Claim ID',
    sortable: false,
    isSorted: 0,
    minWidth: '160px',
  },
  {
    dataName: 'claimId',
    text: 'Claim ID',
    sortable: false,
    isSorted: 0,
    cellType: 'custom',
    minWidth: '105px',
  },
  {
    dataName: 'lineNum',
    text: 'Line',
    sortable: false,
    isSorted: 0,
  },
  {
    dataName: 'dosBegin',
    text: 'Begin DOS',
    sortable: false,
    isSorted: 0,
    minWidth: '130px',
  },
  {
    dataName: 'dosEnd',
    text: 'End DOS',
    sortable: false,
    isSorted: 0,
    minWidth: '130px',
  },
  {
    dataName: 'pos',
    text: 'POS',
    sortable: false,
    isSorted: 0,
    minWidth: '95px',
  },
  {
    dataName: 'code',
    text: 'Code',
    sortable: false,
    isSorted: 0,
  },
  {
    dataName: 'units',
    text: 'Unit',
    sortable: false,
    isSorted: 0,
    minWidth: '80px',
    align: 'right',
  },
  {
    dataName: 'billedCharge',
    text: 'Billed Charge',
    sortable: false,
    isSorted: 0,
    align: 'right',
  },

  {
    dataName: 'allowed',
    text: 'Allowed',
    sortable: false,
    isSorted: 0,
    align: 'right',
  },
  {
    dataName: 'savings',
    text: 'Savings',
    sortable: false,
    isSorted: 0,
    minWidth: '100px',
    align: 'right',
  },
  {
    dataName: 'recAmount',
    text: 'Rec. Amount',
    sortable: true,
    isSorted: 0,
    minWidth: '150px',
    align: 'right',
  },
]);

export const APPEALS_OF_CLAIMID_GRID_COLUMNS = new Set([
  {
    dataName: 'appealLink',
    text: 'Appeal ID',
    sortable: false,
    isSorted: 0,
    minWidth: '160px',
    cellType: 'custom',
  },
  {
    dataName: 'statusChip',
    text: 'Appeal Status',
    sortable: false,
    isSorted: 0,
    minWidth: '160px',
    cellType: 'chip',
  },
  {
    dataName: 'submitDate',
    text: 'Create Date',
    sortable: false,
    isSorted: 0,
    minWidth: '160px',
  },
  {
    dataName: 'completeDate',
    text: 'Complete Date',
    sortable: false,
    isSorted: 0,
    minWidth: '160px',
  },
  {
    dataName: 'appealReason',
    text: 'Reason for Appeal',
    sortable: false,
    isSorted: 0,
    minWidth: '160px',
  },
  {
    dataName: 'submitterName',
    text: 'Created By',
    sortable: false,
    isSorted: 0,
    minWidth: '160px',
  },
  {
    dataName: 'submitterEmail',
    text: 'Email Address',
    sortable: false,
    isSorted: 0,
    minWidth: '160px',
  },
  {
    dataName: 'assignedTo',
    text: 'Assigned To',
    sortable: false,
    isSorted: 0,
    minWidth: '160px',
  },
]);

export const INQUIRIES_OF_CLAIMID_GRID_COLUMNS = new Set([
  {
    dataName: 'inquiryLink',
    text: 'Inquiry ID',
    sortable: true,
    isSorted: 1,
    minWidth: '140px',
    cellType: 'custom',
  },
  {
    dataName: 'statusChip',
    text: 'Inquiry Status',
    sortable: false,
    isSorted: 0,
    minWidth: '160px',
    cellType: 'chip',
  },
  {
    dataName: 'dateCreated',
    text: 'Create Date',
    sortable: true,
    isSorted: 0,
    minWidth: '130px',
  },
  {
    dataName: 'dateCompleted',
    text: 'Complete Date',
    sortable: true,
    isSorted: 0,
    minWidth: '140px',
  },
  {
    dataName: 'details',
    text: 'Details',
    sortable: true,
    isSorted: 0,
    minWidth: '200px',
    cellType: 'custom',
  },
  {
    dataName: 'userAccount',
    text: 'Created By',
    sortable: true,
    isSorted: 0,
    minWidth: '160px',
  },
  {
    dataName: 'email',
    text: 'Email Address',
    sortable: true,
    isSorted: 0,
    minWidth: '200px',
  },
  {
    dataName: 'assignToUser',
    text: 'Assigned To',
    sortable: true,
    isSorted: 0,
    minWidth: '150px',
  },
]);

export const CLAIM_INVOICE_ACTIVITIES_COLUMNS = new Set([
  {
    dataName: 'activity',
    text: 'Activity',
    sortable: true,
    isSorted: 0,
    minWidth: '160px',
  },
  {
    dataName: 'activityDate',
    text: 'Activity Date',
    sortable: true,
    isSorted: 0,
    minWidth: '210px',
  },
  {
    dataName: 'service',
    text: 'Service',
    sortable: true,
    isSorted: 0,
    minWidth: '200px',
  },
  {
    dataName: 'status',
    text: 'Status',
    sortable: true,
    isSorted: 0,
    minWidth: '110px',
  },
  {
    dataName: 'charge',
    text: 'Charge',
    sortable: true,
    isSorted: 0,
    minWidth: '100px',
    align: 'right',
  },
  {
    dataName: 'savings',
    text: 'Savings',
    sortable: true,
    isSorted: 0,
    minWidth: '100px',
    align: 'right',
  },
  {
    dataName: 'comments',
    text: 'Comments',
    sortable: true,
    isSorted: 0,
    minWidth: '320px',
  },
  {
    dataName: 'userName',
    text: 'User',
    sortable: true,
    isSorted: 0,
    minWidth: '150px',
  },
  {
    dataName: 'type',
    text: 'Type',
    sortable: true,
    isSorted: 0,
    minWidth: '200px',
  },
  {
    dataName: 'fee',
    text: 'Fee',
    sortable: true,
    isSorted: 0,
    minWidth: '100px',
    align: 'right',
  },
]);

export const CLAIM_ROUTING_DATA_COLUMNS = new Set([
  {
    dataName: 'sequence',
    text: 'Sequence',
    sortable: true,
    isSorted: 0,
    minWidth: '150px',
  },
  {
    dataName: 'service',
    text: 'Service',
    sortable: true,
    isSorted: 0,
    minWidth: '350px',
  },
  {
    dataName: 'eligibilityComment',
    text: 'Eligibility Comment',
    sortable: true,
    isSorted: 0,
    minWidth: '350px',
  },
  {
    dataName: 'timeStamp',
    text: 'Date/Time Stamp',
    sortable: true,
    isSorted: 0,
    minWidth: '180px',
  },
  {
    dataName: 'routingComment',
    text: 'Routing Comment',
    sortable: true,
    isSorted: 0,
    minWidth: '200px',
  },
  {
    dataName: 'savingsFromService',
    text: 'Savings Returned',
    sortable: true,
    isSorted: 0,
    minWidth: '180px',
    align: 'right',
  },
  {
    dataName: 'commentFromService',
    text: 'Service Comments',
    sortable: true,
    isSorted: 0,
    minWidth: '350px',
  },
]);

export const InitialStatePrePayClaimsPage: PrepayClaimsPageStateType = {
  isEditMode: false,
  isGlobalSearch: false,
  claimLineGridData: [],
  claimPatientGridData: {} as PrepayClaimPatientType,
  claimMemberGridData: {} as PrepayClaimMemberType,
  claimHeaderDetails: {} as PrepayClaimHeaderType,
  isClaimLinesLoading: false,
  providerData: [],
  isProviderLoading: false,
  isClaimHeaderLoading: false,
  isClaimCustomNotesLoading: false,
  isClaimAttachmentsLoading: false,
  isDetailPaneLoading: false,
  attachmentsData: [],
  caseSearchData: [],
  appealsOfClaimIdData: [],
  isAppealsOfClaimIdLoading: false,
  breadCrumbItemsDetailPane: [],
  claimInvoiceActivitiesData: [],
  isClaimInvoiceActivitiesLoading: false,
  isCreateInquiryLookUpdataLoading: false,
  isCreatePortalEorLoading: false,
  isEorVersionsLoading: false,
  eorVersionsData: [],
  inquiryIdCreated: 0,
  isCreateInquirySaveComplete: false,
  isUpdateInquiryComplete: false,
  isUpdateInquiryLoading: false,
  clientNetworks: [],
  clientServices: [],
  isAdjustSavingDropdownLoading: false,
  isAdjustSavingsLoading: false,
  isClaimRoutingLoading: false,
  isClaimOperationsActionLoading: false,
  claimRoutingData: [],
  claimOperations: [],
  adjustmentReasons: [],
  adjustmentStatuses: [],
  isClaimActivityInfoLoading: false,
  claimActivityInfoData: [],
};

export const allowedFileTypes = [
  'image/jpeg',
  'image/png',
  'image/tiff',
  'image/tif',
  'application/vnd.ms-excel',
  '.csv',
  'text/csv',
  'application/csv',
  'text/x-csv',
  'text/html',
  'application/x-csv',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/docx',
  'application/pdf',
  'text/plain',
  'application/msword',
  '.msg',
  'application/pdf',
  '.pdf',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-outlook',
];

export const reasonsForAppeal = [
  {
    id: 'providerDisputingNetworkParticipation',
    label: 'Provider disputing network participation',
    value: 'providerDisputingNetworkParticipation',
  },
  {
    id: 'providerDisputingDiscount',
    label: 'Provider disputing discount',
    value: 'providerDisputingDiscount',
  },
  {
    id: 'providerBalanceBillingMember',
    label: 'Provider balance billing member',
    value: 'providerBalanceBillingMember',
  },
  {
    id: 'providerDisputingNegotiations',
    label: 'Provider Disputing Negotiations',
    value: 'providerDisputingNegotiations',
  },
  {
    id: 'latePayment',
    label: 'Late Payment',
    value: 'latePayment',
  },
  {
    id: 'patientResponsibilityLargerThanAgreed',
    label: 'Patient Responsibility Larger than Agreed',
    value: 'patientResponsibilityLargerThanAgreed',
  },
  {
    id: 'providerAppealingInsightSummaryReviewFindings',
    label: 'Provider appealing insight summary review findings',
    value: 'providerAppealingInsightSummaryReviewFindings',
  },
  {
    id: 'providerProposedSavings',
    label: 'Provider proposed savings',
    value: 'providerProposedSavings',
  },
  {
    id: 'providerDisputingReduction',
    label: 'Provider Disputing Reduction',
    value: 'providerDisputingReduction',
  },
  {
    id: 'other',
    label: 'Other',
    value: 'other',
  },
];

export const documentTypes = [
  {
    id: 'appealLetter',
    label: 'Appeal Letter',
    value: 'appealLetter',
  },
  {
    id: 'radiologyReport',
    label: 'Radiology Report',
    value: 'radiologyReport',
  },
  {
    id: 'copyOfEOB',
    label: 'Copy of EOB',
    value: 'copyOfEOB',
  },
  {
    id: 'labReport',
    label: 'Lab Report',
    value: 'labReport',
  },
  {
    id: 'visitNotes',
    label: 'Visit Notes',
    value: 'visitNotes',
  },
  {
    id: 'pathologyReport',
    label: 'Pathology Report',
    value: 'pathologyReport',
  },
  {
    id: 'correctedClaim',
    label: 'Corrected Claim',
    value: 'correctedClaim',
  },
  {
    id: 'other',
    label: 'Other',
    value: 'other',
  },
  {
    id: 'operativeReport',
    label: 'Operative Report',
    value: 'operativeReport',
  },
  {
    id: 'copyOfClaim',
    label: 'Copy of Claim',
    value: 'copyOfClaim',
  },
];

export const appealSources: SelectDropdownValue[] = [
  {
    label: 'Client',
    value: '1',
  },
  {
    label: 'Client-Provider',
    value: '2',
  },
  {
    label: 'Client-Member',
    value: '3',
  },
];

export const defaultAppealTypeFlagID = '128';

//NOTE: Growing list
export const validClaimOperationsList = [
  { label: 'ADVANCE WITH NO SAVINGS', value: 'advanceWithNoSavings' },
  { label: 'OVERRIDE DUPLICATE CHECK', value: 'overrideDuplicateCheck' },
  { label: 'RETURN WITH NO SAVINGS', value: 'returnWithNoSavings' },
  { label: 'REMOVE MOD. REDUCTION & EXCLUDE', value: 'removeModReductionExclude' },
  { label: 'REMOVE CLIENT ALLOWABLE', value: 'removeClientAllowable' },
  { label: 'RETURN WITH SAVINGS', value: 'returnWithSavings' },
  { label: 'VOID', value: 'void' },
];

export const CLAIM_ACTIVITY_GRID_COLUMNS = new Set([
  {
    dataName: 'userName',
    text: 'User',
    sortable: true,
    isSorted: 0,
    headerWidth: 150,
    isHeaderTruncated: true,
  },
  {
    dataName: 'activity',
    text: 'Activity',
    sortable: true,
    isSorted: 0,
    headerWidth: 150,
    isHeaderTruncated: true,
  },
  {
    dataName: 'description',
    text: 'Description',
    sortable: true,
    isSorted: 0,
    headerWidth: 220,
    isHeaderTruncated: true,
    cellType: 'custom',
  },
  {
    dataName: 'dateTime',
    text: 'Date/Time',
    sortable: true,
    isSorted: 0,
    headerWidth: 150,
    isHeaderTruncated: true,
  },
]);
